import React, { useState } from "react";
import '../styles/UserInfo.css'; 

const UserInfo = () => {
  const [user, setUser] = useState({
    name: "Nguyễn Văn AA",
    email: "nvA@gmail.com",
    password: "123456",
    age: 18,
    hometown: "",
    avatar: "/logo192.png",
  });

  const [isEditing, setIsEditing] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUser((prevUser) => ({ ...prevUser, [name]: value }));
  };

  const handlePasswordToggle = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="user-info-container">
      <div className="user-avatar">
        <img src={user.avatar} alt="Avatar" />
      </div>
      <h2>Thông tin người dùng</h2>
      <form className="user-info-form">
        <div className="form-group">
          <label className="fromhh">Họ và tên:</label>
          <input
            type="text"
            name="name"
            value={user.name}
            onChange={handleInputChange}
            readOnly={!isEditing}
          />
        </div>
        <div className="form-group">
          <label className="fromhh">Email:</label>
          <input
            type="email"
            name="email"
            value={user.email}
            onChange={handleInputChange}
            readOnly={!isEditing}
          />
        </div>
        <div className="form-group">
          <label className="fromhh">Mật khẩu:</label>
          <div className="password-container">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={user.password}
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
            <button
              type="button"
              onClick={handlePasswordToggle}
              className="toggle-password-button"
            >
              {showPassword ? "Ẩn" : "Hiện"}
            </button>
          </div>
        </div>
        <div className="form-group">
          <label className="fromhh">Tuổi:</label>
          <input
            type="number"
            name="age"
            value={user.age}
            onChange={handleInputChange}
            readOnly={!isEditing}
          />
        </div>
        <div className="form-group">
          <label className="fromhh">Quê quán:</label>
          <input
            type="text"
            name="hometown"
            value={user.hometown}
            onChange={handleInputChange}
            readOnly={!isEditing}
          />
        </div>
        <button type="button" onClick={handleEditToggle} className="edit-button">
          {isEditing ? "Lưu" : "Chỉnh sửa"}
        </button>
      </form>
    </div>
  );
};

export default UserInfo;
